import axiosClient from "./axiosClient";

const reservationApi = {
  async getAteliers() {
    const response = await axiosClient.get("/ateliers/");
    return response.data;
  },

  async createAtelier(atelierData) {
    const response = await axiosClient.post("/ateliers/", atelierData);
    return response.data;
  },

  async updateAtelier(atelierId, atelierData) {
    const response = await axiosClient.put(
      `/ateliers/${atelierId}/`,
      atelierData
    );
    return response.data;
  },

  async deleteAtelier(atelierId) {
    await axiosClient.delete(`/ateliers/${atelierId}/`);
  },

  async getZones() {
    const response = await axiosClient.get("/zones/");
    return response.data;
  },

  async createZone(zoneData) {
    const response = await axiosClient.post("/zones/", zoneData);
    return response.data;
  },

  async updateZone(zoneId, zoneData) {
    const response = await axiosClient.put(`/zones/${zoneId}/`, zoneData);
    return response.data;
  },

  async deleteZone(zoneId) {
    await axiosClient.delete(`/zones/${zoneId}/`);
  },

  async getDisponibiliteMois({ annee, mois, atelier }) {
    const response = await axiosClient.get("disponibilite-mois/", {
      params: { annee, mois, atelier },
    });
    return response.data;
  },

  async getDisponibiliteJour({ date, atelier }) {
    const response = await axiosClient.get("disponibilite-jour/", {
      params: { date, atelier },
    });
    return response.data;
  },

  async getMonthReservations({ annee, mois }) {
    const response = await axiosClient.get("/month-reservations/", {
      params: { annee, mois },
    });
    return response.data;
  },

  async createReservation(reservationData) {
    const response = await axiosClient.post("/creneauAtelier/", reservationData);
    return response.data;
  },

  async fetchReservationByToken(creneauId, token) {
    const response = await axiosClient.get(`/creneauAtelier/${creneauId}/`, {
      params: { token },
    });
    return response.data;
  },

  async getReservationsBySlot({ date, heure, zone, filtreAnnule }) {
    const params = { date };
    if (heure !== undefined && heure !== null && heure !== "") {
      params.heure = heure;
    } 
    if (zone !== undefined && zone !== null && zone !== "") {
      params.zone = zone;
    }
    if (filtreAnnule !== undefined) {
      params.filtreAnnule = filtreAnnule;
    }
    const response = await axiosClient.get("/reservations/", {
      params,
    });
    return response.data;
  },

  async updateReservation(creneauId, token, updateData) {
    const config = {};
    if (token) {
      config.params = { token };
    }
    const response = await axiosClient.put(
      `/creneauAtelier/${creneauId}/`,
      updateData,
      config
    );
    return response.data;
  },

  async deleteReservation(creneauId, tokenOrOptions) {
    let token = tokenOrOptions;
    let commentaire;

    if (
      typeof tokenOrOptions === "object" &&
      tokenOrOptions !== null &&
      !Array.isArray(tokenOrOptions)
    ) {
      token = tokenOrOptions.token;
      commentaire = tokenOrOptions.commentaire;
    }

    const config = {};
    if (token) {
      config.params = { token };
    }
    if (commentaire !== undefined) {
      config.data = { commentaire };
    }

    await axiosClient.delete(`/creneauAtelier/${creneauId}/`, config);
  },
};

export const {
  getAteliers,
  createAtelier,
  updateAtelier,
  deleteAtelier,
  getZones,
  createZone,
  updateZone,
  deleteZone,
  getDisponibiliteMois,
  getDisponibiliteJour,
  createReservation,
  fetchReservationByToken,
  updateReservation,
  deleteReservation,
  getReservationsBySlot,
} = reservationApi;

export default reservationApi;
